"use client";
import BreadCrumbList from "@/components/shared/breadCrumbList";
import Text from "@/components/shared/text";
import useLocalizer from "@/hooks/useLocalizer";
import { Link } from "@/i18n/routing";
import { cn, getFilePath } from "@/lib/utils/utils";
import { ClientProjectsSection } from "@/types/project";
import Image from "next/image";
interface Props {
  data: ClientProjectsSection;
  className?: string;
}
const ProjectsContent = ({ data, className }: Props) => {
  const { isRtl, t } = useLocalizer();
  const clientProjects = data;
  return (
    <section className={cn("relative", className)}>
      <div className="relative h-80">
        <div
          className="w-full h-full absolute -top-10 bg-cover bg-center bg-no-repeat"
          style={{
            backgroundImage: clientProjects.banner
              ? `url('${getFilePath(clientProjects.banner?.key)}')`
              : undefined,
          }}
        >
          <div className="w-full h-full bg-black/50 flex justify-center items-center z-20 flex-col">
            <BreadCrumbList
              items={[
                {
                  name: t("pages.home"),
                  href: "/",
                },
                {
                  name: t("pages.projects"),
                },
              ]}
            />
            <Text as="h4" className="font-bold text-white">
              {isRtl ? clientProjects?.arTitle : clientProjects?.enTitle}
            </Text>
          </div>
        </div>
      </div>
      <div className="w-full h-full mb-20 mt-10 px-5 lg:px-0 ">
        <div className="container mx-auto w-full h-full">
          <div className="grid lg:grid-cols-2 xl:grid-cols-3 w-full gap-6">
            {clientProjects?.projects?.map((project, index) => (
              <article
                key={index}
                className="w-full h-[520px]   border-b border-r border-l border-primary/20 bg-white flex flex-col justify-between z-20 overflow-hidden  hover:[&_.cover]:h-full hover:[&_.cover]:rotate-x-0 hover:[&_.cover]:rotate-y-0"
              >
                <div className="relative overflow-hidden h-full w-full transition-all duration-300 ease-in-out ">
                  <Image
                    src={getFilePath(project.image?.key ?? "")}
                    alt="project"
                    fill
                    priority
                    placeholder="empty"
                    className="object-cover"
                  />
                  <Link
                    href={`projects/${project.id}`}
                    aria-label={isRtl ? project?.arTitle : project?.enTitle}
                  >
                    <div className="cover transform-3d rotate-x-90 rotate-y-90 absolute bg-secondary/90 top-0 bottom-0 w-full h-0  z-20 hover:[&_.vertical-line]:h-full hover:[&_.horizontal-line]:w-full hover:[&_.details]:opacity-100 transition-all duration-500 ease-in-out">
                      <div className="relative h-full w-full overflow-hidden flex flex-col justify-center items-center">
                        <div
                          className={cn(
                            "vertical-line absolute bg-primary w-0.5 top-0 bottom-0 h-0 delay-75 transition-all duration-500 ease-in-out",
                            isRtl ? "right-15" : "left-15",
                          )}
                        />
                        <div
                          className={cn(
                            "horizontal-line absolute bg-primary translate-x-1/2 w-0 h-0.5 bottom-20 delay-75 transition-all duration-500 ease-in-out",
                            isRtl ? "left-1/2  right-0" : "right-1/2  left-0",
                          )}
                        />
                        <div
                          className={cn(
                            "details  flex-1 p-20 flex flex-col gap-8 opacity-0 transition-all duration-300 ease-in-out",
                          )}
                        >
                          <Text
                            as="h5"
                            className="text-white font-bold line-clamp-1 lg:line-clamp-2 truncate lg:text-lg text-sm"
                          >
                            {isRtl ? project?.arTitle : project?.enTitle}
                          </Text>
                          <Text className="text-white/70 text-sm xl:text-base line-clamp-2">
                            {isRtl ? project?.arSubTitle : project?.enSubTitle}
                          </Text>
                        </div>
                      </div>
                    </div>
                  </Link>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProjectsContent;
